import React, {useCallback, useState} from "react";
import CrudModule, {ItemField, OnSubmitDone} from "../../../Crudder/CrudModule";
import {CurrencyResponse} from "../../../Api/data/currency/types";
import {getAllCurrencies} from "../../../Api/data/currency/client";
import {useKeycloak} from "@react-keycloak/web";
import {OfferRequest, OfferResponse, OfferState, RealizationPlace} from "../../../Api/data/offer/types";
import {
    addOffer,
    deleteOffer,
    getAllOffers,
    getInitialData,
    getOfferDetails,
    updateOffer
} from "../../../Api/data/offer/client";
import {Box, Grid, MenuItem, Link as MuiLink} from "@material-ui/core";
import {Link} from "react-router-dom";
import InputSelect from "../../../Crudder/components/InputSelect";
import {getAllCompanies} from "../../../Api/data/company/client";
import {CompanyResponse} from "../../../Api/data/company/types";
import {formatNumber, formatNumberThousands} from "../../../../utils/Date";
import {dateFormatter, normalizeStateLabel} from "../../../Crudder/utils/utils";
import createDecorator from "final-form-calculate";
import OfferItemsFormPart from "./components/OfferItemsFormPart";
import OfferForm from "./components/OfferForm";

// Create Decorator
const decorator = createDecorator(
    // Calculations:
    {
        field: /items\[\d+\]\.price/,
        updates: (value, name, allValues) => {

            // const toField = name.replace('price', 'inOfferCurrency')

            // const toValue = getIn(allValues, toField);

            const total = (allValues?.["items"] || [])
                .map(i => i.price ?? 0)
                .reduce(
                    (sum, value) => sum + parseInt(value),
                    0
                );


            return {
                // [toField]: formatNumber(value / exchangeRate),
                total: total,
                // totalInOfferCurrency: formatNumber(total / exchangeRate),
            }
        }
    },
    {
        field: "currency",
        updates: (value, name, allValues) => {

            // const toField = name.replace('price', 'inOfferCurrency')


            const updates = {}


            return updates;
        }

    }
);

const fields : ItemField<any>[] = [
    {
        name: "offerID",
        title: "ID",
        description: "ID",
        columnDef: {
            width: 50,
            ignore: true,
        },
        formFieldDef: {
            ignore: true
        }
    },
    {
        name: "number",
        title: "Číslo",
        columnDef: {
            flex: 0,
            hide: true,
        },
    },
    {
        name: "orderNumber",
        title: "Číslo objednávky",
        columnDef: {
            flex: 0,
            width: 150,
            hide: true,
        },
    },
    {
        name: "date",
        title: "Datum",
        columnDef: {
            width: 90,
            type: "date",
            valueFormatter: dateFormatter
        },
        formFieldDef: {
            type: "date"
        }
    },
    {
        name: "company",
        title: "Firma",
        columnDef: {
            flex: 2,
            minWidth: 150,
            valueGetter: (cell) => {
                return cell.value?.name
            },
            // valueFormatter: (params) => {
            //     return params.value.name;
            // }
        },
    },
    {
        name: "total",
        title: "Cena",
        columnDef: {
            width: 90,
            type: "number",
            renderCell: ({ value }) => formatNumberThousands(formatNumber(value)),
            valueFormatter: ({ value }) => value,
        },
        // formFieldDef: {
        //     type: "date"
        // }
    },
    {
        name: "currency",
        title: "Měna",
        columnDef: {
            flex: 0,
            hide: true,
            valueGetter: (params) => {
                return params.value?.alpha3Code;
            }
        },
    },
    {
        name: "items",
        title: "Položky",
        columnDef: {
            flex: 3,
            minWidth: 200,
            valueGetter: (cell) => {
                return cell.value?.map(item => `${item.title} ${item.description}`)?.join(" ")
            },
            renderCell:(cell) => {
                return <Grid container direction={"row"}>
                    {cell.row.items?.map(item => (
                        <>
                            <Grid item xs={12}>
                                {item.title}
                            </Grid>
                            <Grid item xs={12}>
                                &nbsp;-&nbsp;{item.description}
                            </Grid>
                        </>
                    ))}
                </Grid>
            },
        },
        formFieldDef: {
            render: (field, classes, form, readonly) => (
                <OfferItemsFormPart field={field} readonly={readonly} form={form} />
            )
        }
    },
    {
        name: "note",
        title: "Poznámka",
        columnDef: {
            minWidth: 150,
            flex: 2,
        },
    },
    {
        name: "offerState",
        title: "Stav",
        columnDef: {
            width: 100,
            valueGetter: (params) => {
                return normalizeStateLabel(params.value);
            },
            renderCell: (cell) => (
                <Box style={{fontWeight: cell.value == OfferState.Paid?'bold':'normal'}}>{normalizeStateLabel(cell.value)}</Box>
            )
        },
    },
    {
        name: "invoices",
        title: "Faktury",
        columnDef: {
            width: 120,
            valueGetter: (cell) => {
                const invoices = cell.row.invoices || [];
                const invoiceNumber = cell.row.invoiceNumber;
                const invoiceNumbers = invoices.map(inv => inv.number).filter(Boolean);

                // Only add invoiceNumber if it's different from all invoice numbers
                if (invoiceNumber && !invoiceNumbers.includes(invoiceNumber)) {
                    invoiceNumbers.push(invoiceNumber);
                }

                return invoiceNumbers.join(" ");
            },
            renderCell: (cell) => {
                const invoices = cell.row.invoices || [];
                const invoiceNumber = cell.row.invoiceNumber; // Text field value

                const hasInvoices = invoices.length > 0;
                const hasInvoiceNumber = invoiceNumber;

                // Check if invoiceNumber matches any of the linked invoice numbers
                const invoiceNumbers = invoices.map(inv => inv.number).filter(Boolean);
                const isDuplicate = hasInvoiceNumber && invoiceNumbers.includes(invoiceNumber);
                const shouldShowInvoiceNumber = hasInvoiceNumber && !isDuplicate;

                if (!hasInvoices && !hasInvoiceNumber) {
                    return <Box>-</Box>;
                }

                return (
                    <Box>
                        {invoices.map((invoice, index) => (
                            <Box key={invoice.invoiceID} style={{display: 'block', marginBottom: '4px'}}>
                                <MuiLink
                                    component={Link}
                                    to={`/offers/invoices/${invoice.invoiceID}`}
                                    color="primary"
                                    underline="hover"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {invoice.number || `Faktura ${invoice.invoiceID}`}
                                </MuiLink>
                            </Box>
                        ))}
                        {shouldShowInvoiceNumber && (
                            <Box style={{display: 'block', color: '#666', fontSize: '0.875rem', marginTop: hasInvoices ? '4px' : '0'}}>
                                {invoiceNumber}
                            </Box>
                        )}
                    </Box>
                );
            },
        },
        formFieldDef: {
            ignore: true
        }
    },
    {
        name: "quoteDate",
        title: "Datum nabídky",
        columnDef: {
            width: 90,
            type: "date",
            hide: true,
            valueFormatter: dateFormatter,
        },
        formFieldDef: {
            type: "date"
        }
    },

    {
        name: "companyID",
        title: "ID firmy",
        columnDef: {
            flex: 2,
            hide: true,
            ignore: true,
        },
        formFieldDef: {
            render: (field, classes, form, readonly) => (
                <InputSelect field={field} readonly={readonly} itemsGetter={async (search) => {
                    const companies: CompanyResponse[] = await getAllCompanies();
                    return companies.map(c => (
                        <MenuItem value={c.companyID}>{c.name}</MenuItem>
                    ))
                }} />
            )
        }
    },
    {
        name: "realizationPlace",
        title: "INT/EXT",
        columnDef: {
            width: 70,
            hide: true,
            valueFormatter: (params) => {
                return params.value == RealizationPlace.Internally ? "INT" : "EXT";
            }
        },
    },
    {
        name: "currencyID",
        title: "ID Měny",
        columnDef: {
            flex: 1,
            hide: true,
            ignore: true,
        },
        formFieldDef: {
            render: (field, classes, form, readonly) => (
                <InputSelect field={field} readonly={readonly} itemsGetter={async (search) => {
                    const currencies: CurrencyResponse[] = await getAllCurrencies();
                    return currencies.map(c => (
                        <MenuItem value={c.currencyID}>{c.name}</MenuItem>
                    ))
                }} />
            )
        }
    },
    {
        name: "exchangeRate",
        title: "Kurz",
        columnDef: {
            flex: 1,
            hide: true,
            ignore: true,
        },
        formFieldDef: {
            ignore: true
        }
    },
];

const OfferModule: React.FC = () => {
    return (
        // <CrudderProvider>
            <OfferModuleInner />
        // </CrudderProvider>
        )
}

const OfferModuleInner: React.FC = () => {

    const [ data, setData ] = useState<OfferResponse[]>([]);

    // const { detailResponse,  } = useOfferContext();



    const { keycloak, initialized: keycloakInitialized } = useKeycloak();

    const fetchData = useCallback(() => {
        return new Promise<OfferResponse[]>((resolve, reject) => {
            getAllOffers().then((data) => {
                setData(data);
                resolve(data)
            })
        });
    }, []);


    const handleSubmit = useCallback((formValues: FormData) => {
        return new Promise<OnSubmitDone>((resolve, reject) => {
            if (formValues["offerID"]) {
                // update
                // @ts-ignore
                updateOffer(formValues["offerID"], formValues as OfferRequest).then((response) => {
                    resolve({id: response.offerID});
                })
            }
            else {
                // create
                // @ts-ignore
                addOffer(formValues as OfferRequest).then((response) => {
                    resolve({id: response.offerID, inserted: true });
                })
            }

        })
    }, []);

    const handleDelete: (values: number) => Promise<void> = useCallback((id: number) => {
        return new Promise<void>((resolve, reject) => {
            deleteOffer(id).then((response) => {
                resolve();
            })
        });
    }, []);

    const getDetail = useCallback((id) => {
        return new Promise<OfferResponse>((resolve, reject) => {
            getOfferDetails(id).then((data) => {
                resolve(data)
            })
        });
    }, [data]);

    const getDefaultData = useCallback(() => {
        return new Promise<OfferResponse>((resolve, reject) => {
            getInitialData().then((data) => {
                resolve(data)
            })
        });
    }, [data]);


    return ( keycloakInitialized && keycloak?.token ? (
            <CrudModule<OfferResponse, OfferRequest>
                name={"Nabídky"}
                list={{
                    title: "Seznam nabídek",
                    getRowID: (currency) => currency.offerID,
                    hideHeader: true,
                    initialState: {
                        sorting: {
                            sortModel: [{ field: 'date', sort: 'desc' }],
                        },
                    },
                    actionsHidden: true,
                }}
                detail={{
                    title: "Detail nabídky",
                    formTemplate: OfferForm as any,
                    decorators: [decorator as any],
                    mutators: {
                        setCurrency: ([ currency ], state, utils) => {
                            utils.changeValue(state, 'currency', () => currency)
                        },
                        setCompany: ([ company ], state, utils) => {
                            utils.changeValue(state, 'company', () => company);
                            // @ts-ignore
                            const currency = state.formState.values.currencyID;
                            if (state.formState.initialValues?.["currencyID"] == currency && company?.currencyID) {
                                // currency not set yet
                                utils.changeValue(state, 'currencyID', () => company?.currencyID);
                            }
                        },
                    }
                }}
                itemFields={fields}
                data={fetchData}
                getDetail={getDetail as any}
                getDefaultData={getDefaultData as any}
                onDelete={handleDelete}
                onSubmit={handleSubmit}
            />
    ) : null

    );
};

export default OfferModule;